export const GATrackingCodeCRSAO = "G-NLXR152G66"
export const GATrackingCodeVantage = "G-7DV1N04HS9"
export const GATrackingCodeCandidATSGrad = "G-9YC2G3BFPH"
export const GATrackingCodeCandidX = "G-0ZSYPP7YHM"
export const GATrackingCodeTest = "G-5QLCQY22E8"
export const GATrackingCodeLateral = "G-7Z0R4JN7SM"
export const SUPPORT_LINK =
  "https://raretechnology.hipporello.net/desk/form/6c4eea59cf5b43c8b1229210288bb97a"

export const LOCAL = "LOCAL"
export const DEV = "DEV"
export const STAGING = "STAGING"
export const PROD = "PROD"

export function getHost() {
  return localStorage.getItem("host") || window.location.hostname
}

const defaultLocalObject = {
  RARE_API_URL: `uk-beta.contextualrecruitment.com`,
  level: LOCAL,
  GA: GATrackingCodeTest,
  BASE_DOMAIN: getHost()
    .split(".")
    .slice(2)
    .join("."),
}

const defaultDevObject = {
  ...defaultLocalObject,
  level: DEV,
}

const defaultStagingObject = {
  ...defaultLocalObject,
  RARE_API_URL: `uk.contextualrecruitment.com`,
  level: STAGING,
}

const defaultProductionObject = {
  ...defaultLocalObject,
  RARE_API_URL: `uk.contextualrecruitment.com`,
  level: PROD,
}

const defaultCandidObject = {
  BASE_URL: "http://localhost:3001/vantage",
  PROFILE_URL: "http://localhost:3000",
  INTERNAL: true,
  email: "support@candidx.io",
  team: "The Rare team",
  domain: "candidx.io",
}

const defaultVantageObject = {
  BASE_URL: "http://localhost:3001/vantage",
  PROFILE_URL: "http://localhost:3000",
  EXTERNAL: true,
  email: "info@vantageapp.io",
  team: "The Vantage team",
}

const defaultATSObject = {
  BASE_URL: "http://localhost:3001/vantage",
  PROFILE_URL: "http://localhost:3000",
  EXTERNAL: true,
  email: "support@candidats.io",
  team: "The Candid ATS team",
  domain: "candidats.io",
}

const defaultLateralObject = {
  BASE_URL: "http://localhost:3001/vantage",
  LATERAL: true,
  email: "support@candidats.io",
  team: "The Candid ATS team",
  domain: "candidats.io",
}

const defaultCRSAOObject = {
  BASE_URL: "http://localhost:3001/vantage",
  CRSAO: true,
  email: "support@contextualrecruitment.com",
  team: "The Rare CRS team",
  domain: "contextualrecruitment.com",
}

export function getConfig(env) {
  switch (env) {
    case "uidev":
      return defaultDevObject
    case "uistaging":
      return defaultStagingObject
    case "candid":
      return {
        ...defaultLocalObject,
        ...defaultCandidObject,
      }
    case "candiddev":
      return {
        ...defaultDevObject,
        ...defaultCandidObject,
        BASE_URL: "https://api-beta.candidx.io/vantage",
        PROFILE_URL: "https://beta.candidx.io",
      }
    case "candidstaging":
      return {
        ...defaultStagingObject,
        ...defaultCandidObject,
        BASE_URL: "https://api-staging.candidx.io/vantage",
        PROFILE_URL: "https://staging.candidx.io",
      }
    case "candidprod":
      return {
        ...defaultProductionObject,
        ...defaultCandidObject,
        GA: GATrackingCodeCandidX,
        RARE_API_URL: `uk.contextualrecruitment.com`,
        BASE_URL: "https://api-prod.candidx.io/vantage",
        PROFILE_URL: "https://candidx.io",
        BASE_DOMAIN: "candidx.io",
      }
    case "vantage":
      return {
        ...defaultLocalObject,
        ...defaultVantageObject,
      }
    case "vantagedev":
      return {
        ...defaultDevObject,
        ...defaultVantageObject,
        BASE_URL: "https://api-beta.candidats.io/vantage",
        PROFILE_URL: "https://beta-portal.vantageapp.io",
      }
    case "vantagestaging":
      return {
        ...defaultStagingObject,
        ...defaultVantageObject,
        BASE_URL: "https://api-staging.candidats.io/vantage",
        PROFILE_URL: "https://staging.vantageapp.io",
      }
    case "vantageprod":
      return {
        ...defaultProductionObject,
        ...defaultVantageObject,
        GA: GATrackingCodeVantage,
        RARE_API_URL: `uk.contextualrecruitment.com`,
        BASE_URL: "https://api-prod.candidats.io/vantage",
        PROFILE_URL: "https://portal.vantageapp.io",
        BASE_DOMAIN: ``,
      }
    case "demo":
      return {
        ...defaultProductionObject,
        ...defaultVantageObject,
        BASE_DOMAIN: ``,
        BASE_URL: "https://api-demo.vantageapp.io/vantage",
        PROFILE_URL: "https://demo.vantageapp.io",
      }
    case "ats":
      return {
        ...defaultLocalObject,
        ...defaultATSObject,
      }
    case "atsdev":
      return {
        ...defaultDevObject,
        ...defaultATSObject,
        BASE_URL: "https://api-beta.candidats.io/vantage",
        PROFILE_URL: "https://beta-portal.vantageapp.io",
      }
    case "atsstaging":
      return {
        ...defaultStagingObject,
        ...defaultATSObject,
        BASE_URL: "https://api-staging.candidats.io/vantage",
        PROFILE_URL: "https://staging.vantageapp.io",
      }
    case "atsprod":
      return {
        ...defaultProductionObject,
        ...defaultATSObject,
        GA: GATrackingCodeCandidATSGrad,
        BASE_URL: "https://api-prod.candidats.io/vantage",
        PROFILE_URL: "https://portal.vantageapp.io",
        BASE_DOMAIN: "candidats.io",
      }
    case "lateral":
      return {
        ...defaultLocalObject,
        ...defaultLateralObject,
      }
    case "lateraldev":
      return {
        ...defaultDevObject,
        ...defaultLateralObject,
        BASE_URL: "https://api-betal.candidats.io/vantage",
      }
    case "lateralstaging":
      return {
        ...defaultStagingObject,
        ...defaultLateralObject,
        BASE_URL: "https://api-stagingl.candidats.io/vantage",
      }
    case "lateralprod":
      return {
        ...defaultProductionObject,
        ...defaultLateralObject,
        GA: GATrackingCodeLateral,
        BASE_URL: "https://api-prodlateral.candidats.io/vantage",
        BASE_DOMAIN: "candidats.io",
      }
    case "crsao":
      return {
        ...defaultLocalObject,
        ...defaultCRSAOObject,
      }
    case "crsaodev":
      return {
        ...defaultDevObject,
        ...defaultCRSAOObject,
        BASE_URL: "https://api-beta.contextualrecruitment.com/vantage",
      }
    case "crsaostaging":
      return {
        ...defaultStagingObject,
        ...defaultCRSAOObject,
        BASE_URL: "https://api-staging.contextualrecruitment.com/vantage",
      }
    case "crsaoprod":
      return {
        ...defaultProductionObject,
        ...defaultCRSAOObject,
        GA: GATrackingCodeCRSAO,
        BASE_URL: "https://api-prod.contextualrecruitment.com/vantage",
        BASE_DOMAIN: "contextualrecruitment.com",
      }
    default:
      return defaultLocalObject
  }
}

const getEnv = () => {
  const host = getHost()
  if (host === "workday.hr.rdev.co.uk") {
    return "atsdev"
  }

  if (host === "workday.hr.rstaging.co.uk") {
    return "atsstaging"
  }

  const local = getConfig(process.env.REACT_APP_API_ENV).level === LOCAL
  if (
    local ||
    (!host.endsWith("rdev.co.uk") && !host.endsWith("rstaging.co.uk"))
  ) {
    return process.env.REACT_APP_API_ENV
  }
  const tokens = host.split(".")
  return `${tokens[0].split("-")[1]}${tokens[2].substring(1)}`
}

export const getClientFromDomain = () => {
  const host = getHost()
  if (host.endsWith("rdev.co.uk") || host.endsWith("rstaging.co.uk")) {
    //pull environment from URL
    const tokens = host.split(".")
    return `${tokens[0].split("-")[0]}`
  }
  return host.split(".")[0]
}

export const getPostFixDomain = () => {
  const host = getHost()
  let result = ""
  if (host.endsWith("rdev.co.uk") || host.endsWith("rstaging.co.uk")) {
    //pull environment from URL
    const tokens = host.split(".")
    result = `-${tokens[0].split("-")[1]}.${tokens
      .slice(1, tokens.length)
      .join(".")}`
  } else {
    result =
      "." +
      host
        .split(".")
        .slice(1, host.length)
        .join(".")
  }
  return result + (window.location.port ? `:${window.location.port}` : ``)
}

const config = getConfig(getEnv())

export const team = config.team
export const email = config.email
export const INTERNAL = config.INTERNAL

export const profileUrl = config.PROFILE_URL

export const baseURL =
  window.location.host.includes(".hr.") ||
  window.location.host.includes(".hrx.") ||
  INTERNAL ||
  window.location.origin.replace("www.", "") === config.PROFILE_URL
    ? config.BASE_URL
    : config.BASE_URL?.replace("api", "apiapp")

export const rareApiUrl = config.RARE_API_URL

export const baseDomain = config.BASE_DOMAIN
export const candidateDomain = config.domain

export const EXTERNAL = config.EXTERNAL
export const LATERAL = config.LATERAL
export const CRSAO = config.CRSAO

export const isDev = config.level === LOCAL || config.level === DEV
export const isStaging = config.level === STAGING
export const isProd = config.level === PROD
export const isLocal = config.level === LOCAL
export const LEVEL = config.level

export const gaCode = config.GA
